export enum fieldTypes {
  TEXT = 'text',
  TEXT_AREA = 'textArea',
  DATE_PICKER = 'datePicker',
  TIME_PICKER = 'timePicker',
  BUTTON = 'button',
  SELECT = 'select',
  RADIO = 'radio',
  FILE_UPLOAD = 'fileUpload',
  CHECKBOX = 'checkbox',
  OPTION_LIST = 'optionList',
  CUSTOM_INPUT_LIST = 'customInputList',
  NUMBER = 'number',
  ADDRESS = 'address',
  MULTI_SELECT = 'multiSelect',
  FILE_UPLOAD_INPUT = 'fileUploadInput',
  BANNER_IMAGE = 'bannerImage',
  MOBILE_INPUT = 'mobileInput',
  LABEL = 'label',
  FILE_UPLOAD_INPUT_V2 = 'fileUploadInputV2',
  DISCLAIMER_MESSAGE = 'disclaimerMessage',
  PASSWORD = 'password',
  CUSTOM_MULTISELECT = 'customMultiselect',
  PROFILE_IMAGE = 'profileImage',
  MAP_IFRAME = 'mapIframe'
}